"use strict";

import React, { useRef } from "react";
import Button, { ButtonSize } from "../Button/Button";
import TextInput, { TextInputSize } from "../TextInput/TextInput";
import CopyToClipboard from "../../behaviors/CopyToClipboard/CopyToClipboard";
import { randomString } from "../../../utils";
var CopyInput = function CopyInput(_ref) {
  var value = _ref.value,
    onCopyCallback = _ref.onCopy,
    label = _ref.label,
    labelHidden = _ref.labelHidden,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? TextInputSize.Medium : _ref$size,
    _ref$buttonContent = _ref.buttonContent,
    buttonContent = _ref$buttonContent === void 0 ? "Copy" : _ref$buttonContent;
  var copyInputRef = useRef(null);
  var copyInputId = useRef("copy-input-".concat(randomString()));
  var handleCopy = function handleCopy(onCopy) {
    onCopyCallback == null ? void 0 : onCopyCallback();
    onCopy();
  };
  var handleInputFocus = function handleInputFocus() {
    var _a;
    (_a = copyInputRef.current) == null ? void 0 : _a.select();
  };
  return /* @__PURE__ */React.createElement(TextInput, {
    readOnly: true,
    className: "kl-copy-input",
    id: copyInputId.current,
    ref: copyInputRef,
    onFocus: handleInputFocus,
    labelHidden: labelHidden,
    value: value,
    label: label,
    size: size,
    endElement: /* @__PURE__ */React.createElement(CopyToClipboard, {
      showTooltipOnCopy: true,
      value: value
    }, function (_ref2) {
      var onCopy = _ref2.onCopy;
      return /* @__PURE__ */React.createElement(Button, {
        "aria-labelledby": "".concat(copyInputId.current, "-label"),
        size: getButtonSize(size),
        onClick: function onClick() {
          return handleCopy(onCopy);
        }
      }, buttonContent);
    })
  });
};
var getButtonSize = function getButtonSize(inputSize) {
  var sizeMap = /* @__PURE__ */new Map([[TextInputSize.Small, ButtonSize.XSmall], [TextInputSize.Medium, ButtonSize.Small], [TextInputSize.Large, ButtonSize.Medium]]);
  return sizeMap.get(inputSize) || ButtonSize.Small;
};
export default CopyInput;